module.exports = __webpack_public_path__ + "img/kittisak.baf2e2b4.jpg";